import React from 'react'
import { Column } from '../ReportPage'
import { Card, H4 } from '@blueprintjs/core'
import JavascriptHeatMap from './javascriptHeatMap.js'
import { IGroup } from '../types'

interface IProps {
  chart: IGroup
  config: any
  height: number
}

export default function HeatMap({ chart, height }: IProps) {
  const containerRef = React.useRef<HTMLDivElement>(null)
  const [width, setWidth] = React.useState<number>(200)
  const [windowWidth, setWindowWidth] = React.useState<number>(window.innerWidth)
  React.useLayoutEffect(() => {
    if (containerRef && containerRef.current) {
      setWidth(containerRef.current.clientWidth)
    }
    const handleResize = () => {
      if (windowWidth !== window.innerWidth && containerRef && containerRef.current) {
        setWidth(containerRef.current.clientWidth)
      }
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [width, windowWidth])
  return (
    <Column>
      <Card style={{ height: '100%', width: '100%' }}>
        <H4>{chart.name}</H4>
        <div ref={containerRef}>
          <JavascriptHeatMap
            width={width}
            height={height}
            data={formatChartData({
              columns: chart.columns,
              columnTypes: chart.columnTypes,
              values: chart.values,
            })}
          />
        </div>
      </Card>
    </Column>
  )
}

const formatChartData = ({
  columns,
  values,
}: {
  columns: any
  columnTypes: string[]
  values: any
}) =>
  values.map((entry: any) => {
    let id = ''
    const obj = columns.reduce((result: any, c: any, i: number) => {
      switch (c) {
        case 'value':
          return { ...result, value: +entry[i] }

        case 'day':
          id = `${id}${entry[i]}`
          return { ...result, day: entry[i] }

        case 'hour':
          id = `${id}${entry[i]}`
          return { ...result, hour: entry[i] }

        default:
          return result
      }
    }, {})

    return { ...obj, id }
  })
